import React from 'react';
import Header from './../components/Header'
import Reciever from './Reciever';

function Publicprofile() {
    return ( <
        div > < Header / >
        <
        Reciever / > < /div>
    )
}

export default Publicprofile